import { injectable } from 'inversify';
import merge from 'lodash/merge';
import { meiliHttpClient } from '../../services/httpClients';
import { BaseRepository } from '../Base.repository';
import type { BaseDocumentModel, SearchDocumentResults } from '../models';
import type { MeiliSearchParams } from '../types';

export type MeiliSearchConfig = {
  expiresAt: Date;
  key: string;
  name: string;
  baseURL: string;
};

@injectable()
export class SearchRepository<
  TModel extends BaseDocumentModel = BaseDocumentModel,
> extends BaseRepository {
  constructor(baseURL: string) {
    super(`${baseURL}/indexes`, meiliHttpClient);
  }

  async search(
    filteringParams: MeiliSearchParams,
    searchParams: MeiliSearchConfig,
  ): Promise<SearchDocumentResults<TModel>> {
    const { name, key } = searchParams;

    const { data } = await this.httpClient.post<SearchDocumentResults<TModel>>(
      `/${name}/search`,
      merge({}, filteringParams, {
        limit: 200, // TEMP default value
      }),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${key}`,
        },
      },
    );

    return data;
  }
}
